<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link" v-if="getCitys[citr].city_name">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <div class="banner">
      <img src="../../assets/img/jieju/agent_banner1.png" class="img_banner" alt />
      <div class="banner_1">
        <div class="banner_left">
          <img src="../../assets/img/guanyu/sh_logo.png" alt />
          <p>商企服代理商火爆招募中</p>
          <p style="font-size:18px;">合作共赢，共享万亿市场</p>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_one">
          <h1>针对代理商六大支持</h1>
          <div class="content_one_1">
            <ul>
              <li>
                <div class="content_one_li">
                  <img src="../../assets/img/jieju/agent_icon_support01.png" alt />
                  <p style="font-size:18px;font-weight:900;margin:18px 0 0 0;">技术保障</p>
                  <p
                    style="font-size:14px;color:#666666;width:308px;margin:19px auto;"
                  >强大的技术团队保证系统安全稳定运行，根据市场需求不断优化升级</p>
                </div>
              </li>
              <li>
                <div class="content_one_li">
                  <img src="../../assets/img/jieju/agent_icon_support02.png" alt />
                  <p style="font-size:18px;font-weight:900;margin:18px 0 0 0;">培训支持</p>
                  <p
                    style="font-size:14px;color:#666666;width:308px;margin:19px auto;"
                  >进行全程运营培训指导，定期举行集中培训，并给予课件及远程视频培训</p>
                </div>
              </li>
              <li>
                <div class="content_one_li">
                  <img src="../../assets/img/jieju/agent_icon_support03.png" alt />
                  <p style="font-size:18px;font-weight:900;margin:18px 0 0 0;">服务支持</p>
                  <p
                    style="font-size:14px;color:#666666;width:308px;margin:19px auto;"
                  >全方位的物料及广告支持，一对一的人工客服支持</p>
                </div>
              </li>
              <li>
                <div class="content_one_li">
                  <img src="../../assets/img/jieju/agent_icon_support04.png" alt />
                  <p style="font-size:18px;font-weight:900;margin:18px 0 0 0;">丰厚返利</p>
                  <p
                    style="font-size:14px;color:#666666;width:308px;margin:19px auto;"
                  >所在地永久交易额4%的高额返利不间断的业绩奖励政策</p>
                </div>
              </li>
              <li>
                <div class="content_one_li">
                  <img src="../../assets/img/jieju/agent_icon_support05.png" alt />
                  <p style="font-size:18px;font-weight:900;margin:18px 0 0 0;">会销支持</p>
                  <p
                    style="font-size:14px;color:#666666;width:308px;margin:19px auto;"
                  >结合当地实际情况派讲师在当地进行企业服务论坛及商会运营等主题会议，促进线上交易成单</p>
                </div>
              </li>
              <li>
                <div class="content_one_li">
                  <img src="../../assets/img/jieju/agent_icon_support06.png" alt />
                  <p style="font-size:18px;font-weight:900;margin:18px 0 0 0;">政策红利</p>
                  <p
                    style="font-size:14px;color:#666666;width:308px;margin:19px auto;"
                  >国家大力支持民营企业发展，政府对营商环境及企业服务越来越重视，“商会改革意见”颁布</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="content_one">
          <h1>怎样可以成为代理商</h1>
          <div class="content_one_2">
            <ul>
              <li>
                <img src="../../assets/img/jieju/agent_dls_sign01.png" alt />
                <p>独立法人资质，有良好的商业信誉和口碑，在当地有一定人脉资源</p>
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_dls_sign02.png" alt />
                <p>认可商企服文化理念，愿意伴随成长</p>
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_dls_sign03.png" alt />
                <p>互联网背景，对企业服务、SAAS行业了解，有商会或者政府从业背书</p>
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_dls_sign04.png" alt />
                <p>认可互联网+企业服务的模式，渴望极大扩展自己政务、商会、企业等高端人脉资源</p>
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_dls_sign05.png" alt />
                <p>具备一定的市场拓展和业务谈判能力，具备投资或创业意识</p>
              </li>
            </ul>
            <div class="content_one_right">
              <img src="../../assets/img/jieju/agent_dls_img.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="content1_1">
        <h1>合作说明</h1>
        <div class="content1_one">
          <ul>
            <li>
              <img src="../../assets/img/jieju/agent_sign_explain.png" alt />
              <div class="content1_one_p">
                <p>商会合作</p>
                <p>免费为商会提供会员管理系统，督促商会使用并给会员推广</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/agent_sign_explain.png" alt />
              <div class="content1_one_p">
                <p>服务商</p>
                <p>进行服务商邀请入驻，督促服务商服务质量</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/agent_sign_explain.png" alt />
              <div class="content1_one_p">
                <p>政府合作</p>
                <p>与当地工商联签署战略合作协议，为与商会及服务商合作做好背书</p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/agent_sign_explain.png" alt />
              <div class="content1_one_p">
                <p>收益</p>
                <p>
                  所代理区域
                  <span style="color:#206DF8;">交易额的4%为代理商收益</span>，收益权限为永久，代理商权利可经总部审核后议价转让
                </p>
              </div>
            </li>
            <li>
              <img src="../../assets/img/jieju/agent_sign_explain.png" alt />
              <div class="content1_one_p">
                <p>业绩保证金</p>
                <p>2到10万不等的业绩保证金，督促代理商在规定时间内完成当地业务开发</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content2">
      <div class="content2_1">
        <div class="content2_one_1">
          <h1>服务收益</h1>
          <p class="content2_one_p">
            区域在线交易订单额的4%
            <span>4%</span>
          </p>
          <ul class="content2_one_ul">
            <li>当地商会（家）</li>
            <li>平均会员数（人）</li>
            <li>消费率（%）</li>
            <li>均客单价（元/年）</li>
            <li>总收益（元/年）</li>
          </ul>
          <div class="content1_one_nive">
            <ul>
              <li>100</li>
              <li>50</li>
              <li>40%</li>
              <li>4000</li>
              <li style="color:#F7681E;">32万</li>
            </ul>
          </div>
          <div class="content1_one_nive1">
            <ul>
              <li>100</li>
              <li>50</li>
              <li>40%</li>
              <li>8000</li>
              <li style="color:#F7681E;">64万</li>
            </ul>
          </div>
          <div class="content1_one_nive">
            <ul>
              <li>100</li>
              <li>100</li>
              <li>40%</li>
              <li>4000</li>
              <li style="color:#F7681E;">64万</li>
            </ul>
          </div>
          <div class="content1_one_nive1">
            <ul>
              <li>100</li>
              <li>100</li>
              <li>40%</li>
              <li>8000</li>
              <li style="color:#F7681E;">128万</li>
            </ul>
          </div>
          <p class="content2_one_p1">当地商会数量 * 平均会员数 * 消费率 * 均客单价 * 4% = 年服务收益</p>
        </div>
        <div class="content2_one_1">
          <h1>代理商合作流程</h1>
          <div class="content2_two">
            <ul>
              <li>
                <img src="../../assets/img/jieju/agent_icon_step01.png" alt />
              </li>
              <li>
                <img src="../../assets/img//sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_icon_step02.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_icon_step03.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_icon_step04.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/agent_icon_step05.png" alt />
              </li>
            </ul>
          </div>
          <div class="content2_two_1">
            <ul>
              <li style="margin:0">
                <p>申请审核</p>
                <p style="font-size:14px;color:#666666">对代理商进行审核筛选</p>
              </li>
              <li>
                <p>签署合作协议</p>
                <p style="font-size:14px;color:#666666">确定业绩范围，缴纳业绩保障金 签署合作协议</p>
              </li>
              <li>
                <p>城市站维护</p>
                <p style="font-size:14px;color:#666666">进行城市站维护，组件团队 确立营销方案</p>
              </li>
              <li>
                <p>客户开发</p>
                <p style="font-size:14px;color:#666666">与当地工商联签署合作协议 进行城市站及客户运营</p>
              </li>
              <li>
                <p>收益</p>
                <p style="font-size:14px;color:#666666">达到要求时退还保证金 每月20日打款上月收益</p>
              </li>
            </ul>
          </div>
          <div class="content2_two_2">
            <img src="../../assets/img/sh_bg_apply.png" alt />
            <p>立即申请代理商，轻松赚取收益</p>
            <p style="font-size:16px;" class="content2_two_2p">
              <a href="#">联系电话：022-8821-9596</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      cent_li: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question01.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li1: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question02.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li2: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question03.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li3: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question04.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      //划过
      munn() {
        this.num1 = 1;
      },
      munn1() {
        this.num1 = 2;
      },
      getCitys: []
    };
  },
  methods: {
    // 跳转
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.comWebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    }
  },
  created() {
    this.getRegion(); //城市
    this.checlogin();
    this.citr = localStorage.getItem("citr");
    this.getCity();
  }
};
</script>

<style scoped>
.content2_two {
  width: 1200px;
  height: 54px;
  margin: 61px auto;
  margin-bottom: 27px;
}

.content2_two ul li {
  float: left;
  padding: 0 0 0 40px;
  line-height: 54px;
}

.content2_two_1 {
  width: 100%;
  height: 60px;
  margin-bottom: 59px;
}

.content2_two_1 ul {
  display: flex;
}

.content2_two_1 ul li {
  width: 20%;
  height: 18px;
  text-align: center;
  margin-left: 120px;
}

.content2_two_1 ul li p {
  width: 150px;
  line-height: 22px;
}

.content2_two_2 {
  width: 1200px;
  height: 144px;
  position: relative;
  overflow: hidden;
}

.content2_two_2 img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content2_two_2 p {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 24px;
}

.content2_two_2p {
  width: 300px;
  height: 44px;
  background: #fff;
  margin: 0 auto;
  color: #007bff;
  border-radius: 25px;
}

.content2_two_2p a {
  color: #007bff;
  line-height: 44px;
}
.content2 {
  width: 100%;
  height: auto;
}

.content2_1 {
  width: 1200px;
  height: 1100px;
  margin: 0 auto;
}

.content2_one {
  width: 100%;
  height: 380px;
  margin-bottom: 144px;
}

.content2_one_1 h1 {
  text-align: center;
  margin-bottom: 80px;
  margin-top: 95px;
}

.content2_one_p {
  text-align: center;
  font-size: 14px;
  color: #222;
  margin-bottom: 60px;
}

.content2_one_p span {
  color: #f7681e;
}

.content2_one_ul {
  width: 100%;
  height: auto;
  display: flex;
}

.content2_one_ul li {
  width: 240px;
  height: 50px;
  border-bottom: 2px solid #008cff;
  text-align: center;
  line-height: 50px;
}

.content1_one_nive {
  width: 100%;
  height: 44px;
}

.content1_one_nive ul {
  display: flex;
}

.content1_one_nive ul li {
  width: 240px;
  text-align: center;
  line-height: 44px;
}

.content1_one_nive1 {
  width: 100%;
  height: 44px;
  background: #ecf0fb;
}

.content1_one_nive1 ul {
  display: flex;
}

.content1_one_nive1 ul li {
  width: 300px;
  text-align: center;
  line-height: 44px;
}

.content2_one_p1 {
  color: #999999;
  font-size: 14px;
  padding: 20px 0;
  text-align: center;
}

.content_two {
  width: 1200px;
  height: 54px;
  margin: 61px auto;
  margin-bottom: 27px;
}

.content_two ul li {
  float: left;
  padding: 0 0 0 40px;
  line-height: 54px;
}

.content_two_1 {
  width: 100%;
  height: 60px;
  margin-bottom: 59px;
}

.content_two_1 ul {
  display: flex;
}

.content_two_1 ul li {
  width: 20%;
  height: 18px;
  text-align: center;
  margin-left: 120px;
}

.content_two_1 ul li p {
  width: 150px;
  line-height: 22px;
}

.content_two_2 {
  width: 1200px;
  height: 144px;
  position: relative;
  overflow: hidden;
}

.content_two_2 img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content_two_2 p {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 24px;
}

.content_two_2p {
  width: 150px;
  height: 44px;
  background: #fff;
  margin: 0 auto;
  color: #007bff;
}

.content_two_2p a {
  color: #007bff;
  line-height: 44px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.banner {
  width: 100%;
  height: 360px;
  position: relative;
}

.img_banner {
  width: 100%;
  height: 100%;
}

.banner_1 {
  width: 1200px;
  height: auto;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}

.banner_left {
  width: 473px;
  height: auto;
  float: left;
}

.banner_left img {
  padding: 39px 0;
  margin-bottom: 50px;
}

.banner_left p {
  font-size: 40px;
  color: #fff;
  line-height: 60px;
}

.banner_right {
  width: 370px;
  height: auto;
  float: right;
}

.banner_right_1 {
  width: 100%;
  height: 370px;
  margin-top: 80px;
  background: #fff;
  border-radius: 5px;
}

/* 内容 */
.cent {
  width: 100%;
  height: auto;
  background: #f8faff;
  overflow: hidden;
}

.cent_1 {
  width: 1200px;
  height: 434px;
  margin: 0 auto;
}

.content_one h1,
.content1_1 h1 {
  text-align: center;
  margin-top: 95px;
  margin-bottom: 80px;
}

.cent_ul li {
  width: 144px;
  height: 170px;
  margin-left: 205px;
  float: left;
}

.cent_ul li p {
  line-height: 23px;
}

.cent_ul li p:last-child {
  text-align: center;
  font-size: 14px;
  color: #666666;
}

.cent_p {
  color: #222222;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.kong {
  width: 100%;
  height: 99px;
}

.content {
  width: 100%;
  height: auto;
  margin-bottom: 144px;
}

.content_1 {
  width: 1200px;
  height: 828px;
  margin: 0 auto;
  position: relative;
}

.content_cent {
  width: 450px;
  height: auto;
  float: right;
  margin-right: 0px;
  margin-top: 150px;
}

.content_cent_p {
  width: 350px;
  color: #222;
  font-size: 14px;
  margin-bottom: 40px;
}

.content_cent1 {
  width: 100%;
  height: 194px;
  border-top: 1px solid #e4e4e4;
}

.content_cent1 ul {
  margin-top: 40px;
}

.content_cent1 ul li {
  width: 36px;
  height: 55px;
  float: left;
  margin: 0 0 0 60px;
  border-bottom: 2px solid #007bff;
  font-size: 18px;
  font-weight: 600;
}

.content_cent1 ul li:first-child {
  margin: 0;
}

.img_content {
  position: absolute;
  bottom: 0;
  left: -50%;
  margin-left: 200px;
}

.content1 {
  width: 100%;
  height: auto;
}

.content1_1 {
  width: 1200px;
  height: 628px;
  margin: 0 auto;
}

.content1_one {
  width: 100%;
  height: 380px;
  margin-bottom: 120px;
}

.content1_one h1 {
  text-align: center;
  margin-bottom: 22px;
  margin-top: 95px;
}

.content_two {
  width: 1200px;
  height: 54px;
  margin: 61px auto;
  margin-bottom: 27px;
}

.content_two ul li {
  float: left;
  padding: 0 0 0 40px;
  line-height: 54px;
}

.content_two_1 {
  width: 100%;
  height: 60px;
  margin-bottom: 59px;
}

.content_two_1 ul {
  display: flex;
}

.content_two_1 ul li {
  width: 20%;
  height: 18px;
  text-align: center;
  margin-left: 120px;
}

.content_two_1 ul li p {
  width: 150px;
  line-height: 22px;
}

.content_two_2 {
  width: 1200px;
  height: 144px;
  position: relative;
  overflow: hidden;
}

.content_two_2 img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content_two_2 p {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 24px;
}

.content_two_2p {
  width: 150px;
  height: 44px;
  background: #fff;
  margin: 0 auto;
  color: #007bff;
}

.content_two_2p a {
  color: #007bff;
  line-height: 44px;
}

.content1_tree {
  width: 100%;
  height: 504px;
  background: #2b2876;
}

.tigong {
  width: 100%;
  height: auto;
}

.tigong_1 {
  width: 1200px;
  height: 720px;
  margin: 0 auto;
}

.tigong_1 h1 {
  text-align: center;
  margin-top: 95px;
  margin-bottom: 62px;
}

.tigong_neir {
  width: 630px;
  height: 464px;
  float: left;
}

.tigong_neir_2 {
  width: 570px;
  height: auto;
  float: right;
}

.tigong_neir_p {
  width: 570px;
  height: 187px;
  overflow: hidden;
}

.tigong_neir_p p {
  width: 341px;
  font-size: 14px;
  margin: 45px 0 0 85px;
}

.kong1 {
  width: 41px;
  height: 6px;
  background: linear-gradient(
    90deg,
    rgba(0, 123, 255, 1),
    rgba(115, 76, 231, 1)
  );
  margin: 34px 0 0 85px;
}

.qiang {
  width: 100%;
  height: auto;
  background: #2b2876;
}

.qiang_1 {
  width: 1200px;
  height: 504px;
  margin: 0 auto;
  overflow: hidden;
}

.qiang_1 h1 {
  text-align: center;
  margin: 82px 0 43px 0;
  color: #fff;
}

.qiang_2 {
  width: 1200px;
  height: 336px;
  position: relative;
}

.qiang_img {
  position: absolute;
  top: 0;
  left: 0;
}

.qiang_2 ul li {
  width: 300px;
  height: auto;
  float: left;
  text-align: center;
}

.qiang_2 ul li img {
  margin-top: 48px;
  margin-bottom: 35px;
}

.qiang_2p {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 25px;
}

.qiang_2p1 {
  width: 90px;
  font-size: 14px;
  margin: 0 auto;
  color: #fff;
}

.content {
  width: 100%;
  height: auto;
}

.content_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.content_one {
  width: 1200px;
  margin-bottom: 30px;
}

.content_one_1 {
  width: 1200px;
  height: 470px;
}

.content_one_1 ul li {
  width: 380px;
  height: 222px;
  border: 1px solid #e6e8ed;
  float: left;
  margin-bottom: 25px;
}

.content_one_1 ul li:nth-child(2),
.content_one_1 ul li:nth-child(5) {
  margin: 0 25px;
}

.content_one_li {
  text-align: center;
}

.content_one_li img {
  margin: 19px 0 0 0;
}

.content_one_2 {
  width: 100%;
  height: 243px;
}

.content_one_2 ul {
  width: 500px;
  float: left;
}

.content_one_2 ul li {
  width: 550px;
  height: 26px;
  margin-bottom: 20px;
}

.content_one_2 ul li img {
  float: left;
  width: 50px;
  height: 26px;
}

.content_one_2 ul li p {
  width: 479px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding: 0 10px;
  line-height: 26px;
  float: left;
}

.content_one_right {
  float: right;
}

.content1 {
  width: 100%;
  background: #f7f6fb;
}

.content1_1 {
  width: 1200px;
  height: 513px;
  overflow: hidden;
}

.content1_one {
  width: 100%;
  height: auto;
}

.content1_one ul li {
  width: 380px;
  height: auto;
  float: left;
  margin-bottom: 50px;
}

.content1_one ul li:nth-child(2),
.content1_one ul li:nth-child(5) {
  margin: 0 20px;
}

.content1_one ul li img {
  float: left;
  margin-right: 10px;
}

.content1_one_p {
  float: left;
  margin-top: 15px;
  line-height: 20px;
}

.content1_one_p p:last-child {
  width: 308px;
  font-size: 14px;
  color: #666666;
}

.content1_one_p p:first-child {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
}

.content2 {
  width: 100%;
  height: auto;
}

.content2_1 {
  width: 1200px;
  height: auto;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}

.koa {
  width: auto;
  text-align: center;
  margin-top: -5px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/jiejue/Hezuo.vue